import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; //useNavigate
import swal from "sweetalert";
import Modal from "./childComponents/popups/Modal";
import Loading from "./childComponents/appComponents/Loading";
import InputField from "./childComponents/inputComponents/InputField";
import SelectField from "./childComponents/inputComponents/SelectField";
import { FaBan } from "react-icons/fa";
import { MdContentPasteSearch, MdDelete } from "react-icons/md";
import { FaRegNewspaper } from "react-icons/fa6";

const Pos = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const BUTTON_NAME = "Search Post"; // Submit Button Name

  const [filteredRecords, setFilteredRecords] = useState([]);

  const [publishedRecords, setPublishedRecords] = useState(0);
  const [draftRecords, setDraftRecords] = useState(0);
  const [trashRecords, setTrashRecords] = useState(0);
  const [btnColor, setBtnColor] = useState("airforce");

  const [displayMessages, setDisplayMessages] = useState("");
  const [searchType, setSearchType] = useState("");

  const [allRecords, setAllRecords] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  });

  //Fetches all Form Data
  const [formData, setFormData] = useState({
    input: {
      startDate: "",
      endDate: "",
      storyTitle: "",
      publisher: "",
      status02: "",
    },
    button: {},
    select: {
      pageLayout: "",
      category: "",
    },
  });

  function extractColumn(arr, column, value) {
    return arr.map((x) => ({
      values: x[value],
      item: x[column],
    }));
  }

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  // Reload Page
  const [reloadState, setReloadState] = useState({
    btnLoading: BUTTON_NAME,
    loading: true,
  });

  // Open Dialogue Box
  const [dialogueState, setDialogueState] = useState({
    modalType: false,
    modalTitle: null,
    trigger: false,
    editpost: null,
    searchScript: null,
  });

  const [options, setOptions] = useState({
    pageLayout: [
      { values: "title_show_echo_01zz", item: "Latest Press" },
      { values: "title_show_echo_01", item: "Public Announcement" },
      { values: "title_show_echo_02", item: "Other News" },
      // { values: "title_show_echo_02zz", item: "2nd Other News" },
      { values: "title_show_echo_03", item: "Speeches" },
      // { values: "title_show_echo_03zz", item: "2nd Speeches" },
      // { values: "title_show_echo_04a", item: "1st News Flash" },
      // { values: "title_show_echo_04b", item: "2nd News Flash" },
      // { values: "title_show_echo_04c", item: "3rd News Flash" },
      // { values: "title_show_echo_01wa17", item: "Highways" },
      // { values: "title_show_echo_01wa18", item: "Services" },
      // { values: "title_show_echo_01wa19", item: "Ongoing" },
      // { values: "title_advert_01wa", item: "1st Flash Banner" },
      // { values: "title_advert_01wb", item: "2nd Flash Banner" },
      // { values: "title_advert_01", item: "1st Photo News" },
      // { values: "title_advert_03", item: "2nd Photo News" },
      { values: "title_advert_02", item: "Poster" },
      // { values: "title_advert_04", item: "2nd Poster" },
      { values: "title_advert_utube", item: "Youtube" },
      { values: "title_show_echo_01wa", item: "Download" },
    ],
    //Latest Press, Public Announcement, 1st Other News, 2nd Other News, 1st Speeches, 2nd Speeches, 1st News Flash, 2nd News Flash, 3rd News Flash, Highways, Services, Ongoing, 1st Flash Banner, 2nd Flash Banner, 1st Photo News, 2nd Photo News, 1st Poster, 2nd Poster, Youtube, Download

    tableSize: [
      { values: "10", item: "10" },
      { values: "20", item: "20" },
      { values: "50", item: "50" },
      { values: "100", item: "100" },
    ],

    category: [],
  });

  //replaces each first character of a word with its uppercase version
  function ucwords(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  useEffect(() => {
    (async () => await fetchPosData())();
    (async () => await populateSelectMenu())();
  }, [dialogueState.editpost]);

  const searchDatabase = (event) => {
    event.preventDefault();
    const selectedType = event.currentTarget.dataset.value;

    setSearchType(selectedType); // still useful for UI display
    fetchPosData(selectedType); // pass value directly
  };

  //Query constructor
  const queryConstructorString = (type = searchType) => {
    let query = "?";
    let messages = "";
    const initializeSearchDate = {};
    // Helper function to handle query string updates
    const addToQuery = (condition, Items, queryKey, value) => {
      if (condition === Items) {
        query += `${queryKey}[eq]=${value}&`;
        messages += `${condition.toUpperCase()}: Post | `;
      }
    };

    // Add query parameters dynamically
    addToQuery(type, "Published", "status02", "publish");
    addToQuery(type, "Draft", "status02", "draft");
    addToQuery(type, "Trash", "status02", "trash");

    const { input, select } = formData;
    //const timestampInSeconds = Math.floor(new Date("2025-06-01").getTime() / 1000);
    if (input.startDate) {
      query += `daterqwTramp[gte]=${Math.floor(
        new Date(input.startDate).getTime() / 1000,
      )}&`;
      messages += `START DATE: ${input.startDate} | `;
      initializeSearchDate.startDate = input.startDate;
    }

    if (input.endDate) {
      query += `daterqwTramp[lte]=${Math.floor(
        new Date(input.endDate).getTime() / 1000,
      )}&`;
      messages += `END DATE: ${input.endDate} | `;
      initializeSearchDate.endDate = input.endDate;
    }

    if (select.pageLayout) {
      query += `columes[eq]=${select.pageLayout}&`;
      messages += `PAGE LAYOUT: ${select.pageLayout} | `;
      //initializeSearchDate.pageLayout = select.pageLayout;
    }

    if (select.category) {
      query += `pageName[eq]=${select.category}&`;
      messages += `CATEGORY: ${select.category} | `;
      //initializeSearchDate.category = select.category;
    }

    if (query === "?") {
      query += "status02[eq]=publish";
    }

    return { query, messages, initializeSearchDate };
  };

  // Fetch All Registry Records
  const fetchPosData = async (
    page = 1,
    customSearchType = searchType,
    customPerPage = perPage,
  ) => {
    const { query, messages, initializeSearchDate } =
      queryConstructorString(customSearchType);

    setDisplayMessages(messages);

    setDialogueState((prev) => ({
      ...prev,
      searchScript: query,
    }));

    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}posdata${query}&page=${page}&per_page=${customPerPage}`,
        ),
        axios.get(`${BASE_URL}posquantity`),
      ]);

      const [PosData, populateNumbering] = responses;

      const records = PosData?.data?.allData || [];

      if (records.length === 0) {
        swal(
          "Oops!",
          "Sorry! we did not find any information in the Post",
          "warning",
        );
        setReloadState({
          btnLoading: BUTTON_NAME,
          loading: false,
        });
      } else {
        setDialogueState((prev) => ({
          ...prev,
          searchDates: initializeSearchDate,
        }));

        setAllRecords(records);
        setFilteredRecords(records);
        setPagination(
          PosData.data.pagination || {
            current_page: 1,
            last_page: 1,
            per_page: 10,
            total: 0,
          },
        );

        setReloadState({
          btnLoading: BUTTON_NAME,
          loading: false,
        });
      }

      populateNumbering.data.publish &&
        setPublishedRecords(populateNumbering.data.publish);
      populateNumbering.data.draft &&
        setDraftRecords(populateNumbering.data.draft);
      populateNumbering.data.trash &&
        setTrashRecords(populateNumbering.data.trash);
    } catch (error) {
      swal("Error", "Error fetching Registry Data", "error");
      console.log(error);
    }
  };

  const populateSelectMenu = async () => {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([axios.get(`${BASE_URL}catdata`)]);

      const [categoryData] = responses;

      // populate the select menu
      const populateSelect = (colume, columeObject, columeName, value) => {
        if (columeObject?.data?.status === 200) {
          return setOptions((prev) => ({
            ...prev,
            [colume]: extractColumn(
              columeObject.data.allData,
              columeName,
              value,
            ),
          }));
        }
      };

      populateSelect("category", categoryData, "webPageName", "id"); //
      populateSelect("getPageLink", categoryData, "webPageName", "id"); //
    } catch (error) {
      swal("Error", "Error fetching Name Data", "error");
      console.log("Error fetching Name Data:", error);
    }
  };

  const getPaginationRange = () => {
    const total = pagination.last_page;
    const current = pagination.current_page;

    const delta = 1; // how many pages around current

    const range = [];
    const rangeStart = Math.max(2, current - delta);
    const rangeEnd = Math.min(total - 1, current + delta);

    range.push(1);

    if (rangeStart > 2) {
      range.push("...");
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      range.push(i);
    }

    if (rangeEnd < total - 1) {
      range.push("...");
    }

    if (total > 1) {
      range.push(total);
    }

    return range;
  };

  const changePage = (page) => {
    if (page >= 1 && page <= pagination.last_page) {
      fetchPosData(page);
    }
  };

  const pages = getPaginationRange();

  // Search
  async function searchData(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));
    fetchPosData();
  }

  const handleFilter = (event) => {
    const text = event.target.value.toLowerCase();

    const newData = filteredRecords.filter(
      (row) =>
        (row.storyTitle ?? "").toLowerCase().includes(text) ||
        (row.publisher ?? "").toLowerCase().includes(text),
    );

    setAllRecords(newData.length > 0 ? newData : allRecords);
  };

  // Open Dialogue Box for Update
  async function updateData(event, posts) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalPos",
      modalTitle: "EDIT POST CONTENT",
      trigger: true,
      editpost: posts,
    }));
    setBtnColor("success");
  }

  // Open Dialogue Box for Draft
  async function draftData(event, id) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const draftItem = async () => {
      await axios.get("sanctum/csrf-cookie").then((response) => {
        axios.delete(`${BASE_URL}posdata/draft/${id}`).then((res) => {
          if (res?.data?.status === 200) {
            formCleanner();
            swal("Drafted", res.data.message, "success");
          } else {
            swal("Oops!", res.data.message, "warning");
          }
        });
      });
    };

    await swal({
      title: "Are you sureee!!?",
      text: "Once set to draft, you will have to publish to recover this data againoo!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        (async () => await draftItem())();
      } else {
        swal("Saved", "The data is safe!", "success");
      }
    });
  }

  // Open Dialogue Box for Fresh Post
  async function addData() {
    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const today = new Date().toISOString().split("T")[0];

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalPos",
      modalTitle: "POST CONTENT",
      trigger: true,
      editpost: {
        creationDate: today,
        category: "1",
        textDisplay: "auto",
        layoutDisplay: "auto",
        width01: "auto",
        status02: "publish",
        chosse009: "2",
      },
    }));

    setBtnColor("airforce");
  }

  // Delete a Row of Data
  async function DeletePost(event, id) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const deleteItem = async () => {
      await axios.get("sanctum/csrf-cookie").then((response) => {
        axios.delete(`${BASE_URL}posdata/${id}`).then((res) => {
          if (res?.data?.status === 200) {
            formCleanner();
            swal("Deleted", res.data.message, "success");
          } else {
            swal("Oops!", res.data.message, "warning");
          }
        });
      });
    };

    await swal({
      title: "Are you sureee!!?",
      text: "Once deleted, you will not be able to recover this data againoo!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        (async () => await deleteItem())();
      } else {
        swal("Saved", "The data is safe!", "success");
      }
    });
  }

  // Open Dialogue Box for Printing Registry
  async function printPos() {
    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalPosPrintout",
      modalTitle: "POST CONTENT",
      trigger: true,
      editpost: allRecords,
    }));

    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));
  }

  // Clean the Form
  const formCleanner = () => {
    setDialogueState((prev) => ({
      ...prev,
      modalType: false,
      modalTitle: null,
      trigger: false,
      editpost: null,
      searchScript: null,
    }));

    fetchPosData();
  };

  if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }
  function softreload() {
    window.location.reload();
  }

  // const getPageNumbers = () => {
  //   const pages = [];
  //   const delta = 1; // pages around current page

  //   const rangeStart = Math.max(2, currentPage - delta);
  //   const rangeEnd = Math.min(npage - 1, currentPage + delta);

  //   pages.push(1);

  //   if (rangeStart > 2) {
  //     pages.push("...");
  //   }

  //   for (let i = rangeStart; i <= rangeEnd; i++) {
  //     pages.push(i);
  //   }

  //   if (rangeEnd < npage - 1) {
  //     pages.push("...");
  //   }

  //   if (npage > 1) {
  //     pages.push(npage);
  //   }

  //   return pages;
  // };

  // const pageNumbers = getPageNumbers();

  return (
    <>
      {/* modal Type, Title of the Modal Box, triger the modal, convay all the data inputs to be edithed to child */}
      <Modal
        modalType={dialogueState.modalType}
        titles={dialogueState.modalTitle}
        trigger={dialogueState.trigger}
        editpost={dialogueState.editpost}
        formCleanner={formCleanner}
        searchDate={dialogueState.searchDates}
        searchScript={dialogueState.searchScript}
        btnColor={btnColor}
      />

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-success p-3">
                <i className="fa fa-search"></i> SEARCH POST
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <div className="col-lg-12 row">
                    <Link
                      to=""
                      className="col-lg-2 pt-4"
                      onClick={searchDatabase}
                      data-value="Published"
                      style={{ fontSize: "16px" }}
                    >
                      <div className="col-12 border-end">
                        <FaRegNewspaper style={{ fontSize: "20px" }} />{" "}
                        Published ({publishedRecords})
                      </div>
                    </Link>

                    <Link
                      to=""
                      className="col-lg-2 pt-4"
                      onClick={searchDatabase}
                      data-value="Draft"
                      style={{ fontSize: "16px" }}
                    >
                      <div className="col-12 border-end">
                        <FaBan style={{ fontSize: "20px" }} /> Draft (
                        {draftRecords})
                      </div>
                    </Link>

                    <Link
                      to=""
                      className="col-lg-2 pt-4"
                      onClick={searchDatabase}
                      data-value="Trash"
                      style={{ fontSize: "16px" }}
                    >
                      <div className="col-12">
                        <MdDelete style={{ fontSize: "20px" }} /> Trash (
                        {trashRecords})
                      </div>
                    </Link>

                    <div className="col-lg-2">
                      <Link
                        className="btn btn-success col-12 mt-4"
                        onClick={softreload}
                        to="/admin/pos"
                      >
                        <i className="fa fa-refresh"></i>
                      </Link>
                    </div>

                    <div className="col-lg-2">
                      <button
                        className="btn btn-danger col-12 mt-4"
                        onClick={printPos}
                        data-toggle="modal"
                        data-target="#exampleModal"
                        disabled
                      >
                        <div className="d-flex justify-content-center">
                          <i className="fa fa-print pt-1 pe-2"></i>
                          Print Document
                        </div>
                      </button>
                    </div>

                    <div className="col-lg-2">
                      <button
                        className="btn btn-primary col-12 mt-4"
                        onClick={addData}
                        data-toggle="modal"
                        data-target="#exampleModal"
                      >
                        <div className=" d-flex justify-content-center">
                          <i className="fa fa-plus-square-o pt-1 pe-2"></i>
                          Add Post
                        </div>
                      </button>
                    </div>
                  </div>

                  <div className="col-lg-12 mt-4 row">
                    <InputField
                      label="Start Date"
                      name="startDate"
                      size="2"
                      placeholder="Please Select Start Date"
                      required=""
                      value={formData.input.startDate}
                      type="date"
                      onChange={updateFormData}
                      icon="fa fa-calendar-check-o"
                    />

                    <InputField
                      label="End Date"
                      name="endDate"
                      size="2"
                      placeholder="Please Select End Date"
                      required=""
                      value={formData.input.endDate}
                      type="date"
                      onChange={updateFormData}
                      icon="fa fa-calendar-check-o"
                    />

                    <SelectField
                      label="Page Layout"
                      name="pageLayout"
                      size="2"
                      placeholder="Select a Page Layout"
                      required="required"
                      value={formData.select.pageLayout}
                      options={options.pageLayout}
                      switchOptions={1}
                      type="text"
                      onChange={updateFormData}
                      icon="fa fa-columns"
                    />

                    <SelectField
                      label="Category"
                      name="category"
                      size="2"
                      placeholder="Select a Category"
                      required="required"
                      value={formData.select.category}
                      options={options.category}
                      switchOptions={1}
                      type="text"
                      onChange={updateFormData}
                      icon="fa fa-tags"
                    />

                    <SelectField
                      label="Table Size"
                      name="tableSize"
                      size="2"
                      placeholder="Select a Table Size"
                      required="required"
                      value={perPage}
                      options={options.tableSize}
                      switchOptions={1}
                      type="text"
                      onChange={(type, key, value) => {
                        setPerPage(value);
                        fetchPosData(1, searchType, value);
                      }}
                      icon="fa fa-columns"
                    />

                    <div className="col-lg-2">
                      <button
                        className="btn btn-success col-12 mt-4"
                        onClick={searchData}
                      >
                        <div className=" d-flex justify-content-center">
                          <i className="fa fa-search pt-1 pe-2"></i>
                          {reloadState.btnLoading}
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-success p-3">
                <MdContentPasteSearch style={{ fontSize: "20px" }} /> Post's
                Dashboard
                <span className="float-end me-3">{displayMessages}</span>
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <div>
                    <div style={{ display: "flex", float: "right" }}>
                      <input
                        type="text"
                        name="searchData"
                        placeholder="Search Post or Staff."
                        style={{ padding: "5px 7px" }}
                        onChange={handleFilter}
                      />
                    </div>
                  </div>
                  <div style={{ width: "100%", overflowX: "scroll" }}>
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col" style={{ width: "2%" }}>
                            Select
                          </th>
                          {[
                            "Action",
                            "Picture",
                            "Status",
                            "Summary",
                            "Title",
                            "Author",
                            "Category",
                            "Publish Date",
                          ].map((items, index) => (
                            <th key={index} scope="col">
                              {items}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {allRecords.map((allRecord, index) => {
                          const formatDate = (dateStr) => {
                            const date = new Date(dateStr);
                            if (isNaN(date)) return "";

                            const day = date.getDate();
                            const suffix =
                              day % 10 === 1 && day !== 11
                                ? "st"
                                : day % 10 === 2 && day !== 12
                                  ? "nd"
                                  : day % 10 === 3 && day !== 13
                                    ? "rd"
                                    : "th";

                            return `${day}${suffix} ${date.toLocaleString("en-GB", { month: "short" })}, ${date.getFullYear()}`;
                          };

                          let passport = allRecord.passport || "";
                          let passport02;

                          const bppCount01 =
                            passport.split("uploads_images").length - 1;
                          const bppCount02 =
                            passport.split("download").length - 1;

                          if (bppCount01 > 0) {
                            passport = "upload/" + passport;
                            passport02 = "upload/" + passport;
                          } else if (bppCount02 > 0) {
                            passport = "upload/" + passport;
                            passport02 = "upload/" + passport;
                          }

                          const bppCount03 = passport.split("pdf").length - 1;

                          passport02 = passport;

                          if (bppCount03 > 0) {
                            passport =
                              "upload/general_images/Adobe Acrobat 9.png";
                          }

                          const storyTitle = allRecord.storyTitle
                            ?.toLowerCase()
                            .toUpperCase();
                          const title = allRecord.title
                            ?.toLowerCase()
                            .toUpperCase();
                          return (
                            <tr key={index}>
                              <th scope="row">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  name={allRecord.id}
                                />
                              </th>
                              <td style={{ width: "20%" }}>
                                <button
                                  type="button"
                                  className="btn btn-success me-3"
                                  data-toggle="modal"
                                  data-target="#exampleModal"
                                  onClick={(event) =>
                                    updateData(event, allRecord)
                                  }
                                >
                                  <i className="fa fa-edit me-1"> </i>
                                  Edit
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-secondary me-3"
                                  data-toggle="modal"
                                  data-target="#exampleModal"
                                  onClick={(event) =>
                                    draftData(event, allRecord.id)
                                  }
                                >
                                  <i className="fa fa-ban me-1"> </i>
                                  Draft
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={(event) =>
                                    DeletePost(event, allRecord.id)
                                  }
                                >
                                  <i className="fa fa-trash me-1"> </i>
                                  Trash
                                </button>
                              </td>

                              <td style={{ width: "10%" }}>
                                <img
                                  src={BACKEND_URL + passport}
                                  alt=""
                                  width={150}
                                />
                              </td>
                              <td style={{ width: "5%" }}>
                                {allRecord.status02}
                              </td>
                              <td style={{ width: "15%" }}>{title}</td>
                              <td style={{ width: "18%" }}>{storyTitle}</td>
                              <td style={{ width: "10%" }}>
                                {allRecord.publisher}
                              </td>
                              <td style={{ width: "10%" }}>
                                {allRecord.webPageName}
                              </td>
                              <td style={{ width: "10%" }}>
                                {formatDate(allRecord.daterqw)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  <nav>
                    <ul className="pagination">
                      {/* Prev */}
                      <li
                        className={`page-item ${pagination.current_page === 1 ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            changePage(pagination.current_page - 1)
                          }
                        >
                          Prev
                        </button>
                      </li>

                      {/* Pages */}
                      {pages.map((page, index) => (
                        <li
                          key={index}
                          className={`page-item ${
                            page === pagination.current_page ? "active" : ""
                          } ${page === "..." ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => page !== "..." && changePage(page)}
                          >
                            {page}
                          </button>
                        </li>
                      ))}

                      {/* Next */}
                      <li
                        className={`page-item ${pagination.current_page === pagination.last_page ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            changePage(pagination.current_page + 1)
                          }
                        >
                          Next
                        </button>
                      </li>

                      <li className="page-item ps-3 pe-3 pt-1 bg-primary text-white">
                        Total: {pagination.total}
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pos;
